module.exports = __webpack_public_path__ + "9c52ef03e6a7c5b3d9e3e2e6987216d4.png";